import useAPI from '@/hooks/useAPI';
import { useQueryResponseMessage } from '@/hooks/useQueryResponseMessage';
import PersonRepository from '@/repositories/PersonRepository';

export const usePersonRunPostSaveTasks = (personId: string, enabled = false) => {
  const personRepository = PersonRepository();
  const queryKey = ['personRunPostSaveTasks', personId];

  const queryResponse = useAPI({
    queryKey,
    queryFn: async () => {
      return await personRepository.runPostSaveTasks(personId);
    },
    enabled
  });

  const { dataUpdatedAt, isSuccess } = queryResponse;

  useQueryResponseMessage({
    dataUpdatedAt,
    isSuccess,
    queryKey,
    successMessage: 'Successfully triggered person sync tasks'
  });

  return queryResponse;
};
